import React from 'react';
import LoadingPlaceholder from 'react-loading-placeholder';

class Loading extends React.Component {
  render() {
    const { loading, rows } = this.props;

    if (loading) {
      return <LoadingPlaceholder numberOfRows={rows || 10} />;
    }

    return this.props.children || <div />;
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/common/loading/index.js